import { ElementRef, EventEmitter, OnInit, TemplateRef } from '@angular/core';
import { CsDropDownItemTemplatesComponent } from '@app/shared/cs-components/cs-drop-down/cs-drop-down-item-templates/cs-drop-down-item-templates.component';
import { CsDropDownTogglerTemplatesComponent } from '@app/shared/cs-components/cs-drop-down/cs-drop-down-toggler-templates/cs-drop-down-toggler-templates.component';
import { ICsDdItem } from '@app/shared/cs-components/cs-drop-down/cs-drop-down.interface';
import { CsDropDownService } from '@app/shared/cs-components/cs-drop-down/cs-drop-down.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { CsFaIcons } from '@app/shared/cs-components/cs-images.';
var CsDropDownComponent = /** @class */ (function () {
    function CsDropDownComponent(_hostRef, _csDdService, _translate) {
        this._hostRef = _hostRef;
        this._csDdService = _csDdService;
        this._translate = _translate;
        this.ddItemClick = new EventEmitter();
        this.ddItemElementClick = new EventEmitter();
        this.pickerClick = new EventEmitter();
        this.thisRef = new EventEmitter();
        this.ddSearchText = '';
        this.ISODateFormat = 'YYYY-MM-DD';
    }
    CsDropDownComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._csDdService.registerDdTemplates(this.togglerTemplates, this.itemTemplates)
            .subscribe(function (res) {
            _this.togglersHolder = res.togglersHolder;
            _this.itemsHolder = res.itemsHolder;
            _this.setInitialConfig();
        });
    };
    CsDropDownComponent.prototype.onDocumentClick = function (event) {
        if (!this._hostRef.nativeElement.contains(event.target)) {
            this.closeDdMenu();
        }
    };
    CsDropDownComponent.prototype.setInitialConfig = function () {
        var _this = this;
        if (this.ddConfig.ddMenuConfig.isGroupItem) {
            this.ddConfig.ddMenuConfig.groupItems.forEach(function (group) {
                group.items.forEach(function (item) {
                    _this._csDdService.setItemConfig(_this.ddConfig, item, group);
                });
            });
        }
        else {
            this.ddConfig.ddMenuConfig.items.forEach(function (item) {
                _this._csDdService.setItemConfig(_this.ddConfig, item);
            });
        }
        this.ddConfig.ddMenuConfig.totalItemsCount = this.filteredItems('ALL').length;
        this.ddConfig.ddMenuConfig.selectedItemsCount = this.filteredItems('SELECTED').length;
    };
    CsDropDownComponent.prototype.onDdShown = function (ddInstance) {
        this._ddInstance = ddInstance;
        this.thisRef.emit(this);
    };
    CsDropDownComponent.prototype.onDdHidden = function () {
        this.ddSearchText = '';
        this.filterOrResetDdItems();
        this._ddInstance = null;
        this.thisRef.emit(null);
    };
    CsDropDownComponent.prototype.onDpShown = function (dpInstance) {
        this._dPInstance = dpInstance;
    };
    CsDropDownComponent.prototype.closeDdMenu = function () {
        if (this._ddInstance) {
            if (this._dPInstance) {
                this._dPInstance.hide();
                this._dPInstance = null;
            }
            this._ddInstance.hide();
        }
    };
    CsDropDownComponent.prototype.closeDdMenuOnElementClick = function (data) {
        if (!data.item.isMultiChoiceItem
            || (data.itemElement && data.itemElement.isDdMenuHide)
            || (data.elType === 'TEXT' && data.item.templateData.isDdMenuHide)) {
            this.closeDdMenu();
        }
    };
    CsDropDownComponent.prototype.toggleFavIcon = function (data) {
        if (data.elType === 'ICON' && data.itemElement.isFavouriteIndicator) {
            data.item.isFavourite = !data.item.isFavourite;
            data.itemElement.src = data.item.isFavourite ? CsFaIcons.starSolid : CsFaIcons.starRegular;
            // data.item.isFavEnabled = data.itemElement.isFavourite;
        }
    };
    CsDropDownComponent.prototype.onDdItemClick = function (item) {
        if (!item.isPicker) {
            this.resetSelectedDdItems(item);
            this.updateTogglerWhileItemSelection(item);
            if (!item.isMultiChoiceItem || item.isDdMenuHide) {
                this.closeDdMenu();
            }
            this.ddItemClick.emit(item);
        }
    };
    CsDropDownComponent.prototype.onDdItemElementClick = function (data) {
        this.resetSelectedDdItems(data.item);
        this.updateTogglerWhileItemSelection(data.item);
        this.toggleFavIcon(data);
        this.closeDdMenuOnElementClick(data);
        this.ddItemElementClick.emit(data);
    };
    CsDropDownComponent.prototype.onPickerClick = function (type, item, val) {
        this.resetSelectedDdItems(item);
        this.updateTogglerWhileItemSelection(item, val);
        if (!item.isMultiChoiceItem || item.isDdMenuHide) {
            this.closeDdMenu();
        }
        this.pickerClick.emit({ item: item, type: type, val: val });
    };
    CsDropDownComponent.prototype.resetSelectedDdItems = function (selectedItem) {
        var _this = this;
        selectedItem.isSelected = selectedItem.isMultiChoiceItem ? !selectedItem.isSelected : true;
        if (!selectedItem.isMultiChoiceItem) {
            if (this.ddConfig.ddMenuConfig.isGroupItem) {
                this.ddConfig.ddMenuConfig.groupItems.find(function (group) {
                    if (group.id === selectedItem.ddGroupId) {
                        _this.resetPreviousSelectedItems(group.items, selectedItem);
                        return true;
                    }
                });
            }
            else {
                this.resetPreviousSelectedItems(this.ddConfig.ddMenuConfig.items, selectedItem);
            }
        }
        // this.updateTogglerWhileItemSelection(selectedItem);
    };
    CsDropDownComponent.prototype.resetPreviousSelectedItems = function (itemsList, selectedItem) {
        itemsList.forEach(function (item) {
            if (item.id !== selectedItem.id) {
                item.isSelected = false;
            }
        });
    };
    CsDropDownComponent.prototype.updateTogglerWhileItemSelection = function (selectedItem, pickerVal) {
        if (selectedItem.isMultiChoiceItem) {
            this.ddConfig.ddMenuConfig.selectedItemsCount = this.filteredItems('SELECTED').length;
        }
        else {
            if (selectedItem.isPicker) {
                switch (selectedItem.pickerType) {
                    case 'DATE':
                        var selectedVal = moment(pickerVal).format('DD-MM-YYYY');
                        this.ddConfig.ddTogglerConfig.templateData['text'] = selectedItem.templateData['text'] + " (" + selectedVal + ")";
                        break;
                    case 'DATE_RANGE':
                        var fromDt = moment(pickerVal[0]).format('DD-MM-YYYY');
                        var toDt = moment(pickerVal[1]).format('DD-MM-YYYY');
                        this.ddConfig.ddTogglerConfig.templateData['text'] = selectedItem.templateData['text'] + " (" + fromDt + " - " + toDt + ")";
                        break;
                }
            }
            else {
                this.ddConfig.ddTogglerConfig.templateData['text'] = selectedItem.templateData['text'];
                this.ddConfig.ddTogglerConfig.templateData['background'] = selectedItem.templateData['background'];
            }
        }
    };
    CsDropDownComponent.prototype.filterOrResetDdItems = function (searchText) {
        var _this = this;
        if (searchText === void 0) { searchText = ''; }
        this.ddSearchText = searchText;
        if (this.ddConfig.ddMenuConfig.isSearchBar) {
            if (this.ddConfig.ddMenuConfig.isGroupItem) {
                this.ddConfig.ddMenuConfig.groupItems.forEach(function (group) {
                    group.items
                        .forEach(function (item) {
                        var itemText = (_this.ddConfig.ddMenuConfig['templateType'] === 'CUSTOM' && !item.templateData['text']) ? item.templateData['customData'][item.templateData['customTextLabelKey']] : item.templateData['text'];
                        item.isHide = !(_this._translate.instant(itemText)).toLowerCase().includes(searchText.toLowerCase());
                    });
                });
            }
            else {
                this.ddConfig.ddMenuConfig.items
                    .forEach(function (item) {
                    var itemText = (_this.ddConfig.ddMenuConfig['templateType'] === 'CUSTOM' && !item.templateData['text']) ? item.templateData['customData'][item.templateData['customTextLabelKey']] : item.templateData['text'];
                    item.isHide = !(_this._translate.instant(itemText)).toLowerCase().includes(searchText.toLowerCase());
                });
            }
        }
    };
    // Helper functions :
    CsDropDownComponent.prototype.getDdMenuGridColumnSetup = function (columns) {
        return "repeat(" + (columns || 1) + ", 1fr)";
    };
    CsDropDownComponent.prototype.filteredItems = function (filterBy) {
        return this._csDdService.getItemsBy(this.ddConfig, filterBy);
    };
    return CsDropDownComponent;
}());
export { CsDropDownComponent };
